import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../../types";
import {
  EventData,
  EventDataParams,
  GetEventData,
  GetSingleEventData,
} from "../../../../types/eventManage/event";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createEventAsync = createAsyncThunk<
  null,
  PostRequest<EventData, CommonOthers>
>(
  "admin/createEvent",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createEvent, data);

      reRender(true);
      toast("success", "Event create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Event create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllEventsAsync = createAsyncThunk<
  GetCommonData<GetEventData>,
  Params<EventDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllEvents", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as EventDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllEvents, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get event fail");
    return rejectWithValue(error);
  }
});

// update
export const updateEventAsync = createAsyncThunk<
  null,
  PostRequest<EventData, GetSingleDataParams>
>(
  "admin/updateEvent",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateEvent}/${id}`, data, {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      });

      reRender && reRender(true);
      toast("success", "Event update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Event update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singEventDataAsync = createAsyncThunk<
  GetSingleEventData,
  Params<GetSingleDataParams>
>("admin/singEventData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(`${BASE_API.getSingleEvent}/${params?.id}`, {
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return data.data?.data;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single event data get fail");
    return rejectWithValue(error);
  }
});
